import React, { Component } from "react";
import styled from "styled-components";

import { $ } from "../../../vendor";
import { ToolTipBadge } from "../../../Components/ToolTip";
import CanvasPreview from "../../../react/components/CanvasPreview";
import { AiGenerateProgress } from "../GeneratePresentation/Components/AiGenerateProgress";
import SlideAiController from "./SlideAiController";

const SLIDE_GAP = 20;

const Container = styled.div`
    width: 100%;
    background: #444;
    overflow-y: scroll;

    &::-webkit-scrollbar-thumb:vertical {
        border-radius: 20px;
        background-color: #666;
        border: 8px 4px 8px 8px solid transparent;
        background-clip: content-box;
    }

    padding: 10px ${SLIDE_GAP}px 30px;
    padding-right: 0px;
`;

const SlidesContainer = styled.div`
    position: relative;
    grid-area: slides;
    display: flex;
    flex-direction: row;
    gap: ${SLIDE_GAP}px;
    flex-wrap: wrap;
`;

const ProgressContainer = styled.div`
    position: relative;
    overflow: hidden;
    height: 100%;
`;

const SlideCategory = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
`;

const CategoryLabel = styled.div`
    display: flex;
    font-weight: bold;
    padding: 5px 0px 5px;
    align-items: center;
    justify-content: center;
    color: white;
    text-transform: uppercase;
`;

class SlideAiIdeasList extends Component {
    constructor(props) {
        super(props);

        let slideWidth = props.slideWidth || (window.innerWidth - SLIDE_GAP * 4 - 80) / 3;

        this.state = {
            slideWidth,
        };

        this.hasBeenUnmounted = false;

        this.ref = React.createRef();
    }

    componentDidMount() {
        // const containerWidth = this.ref.current?.clientWidth;
        // const { cols } = this.props;
        //
        // this.setState({ slideWidth: ((containerWidth - SLIDE_GAP * (cols - 1)) / cols) - SLIDE_GAP - 10 });

        if (!this.props.slideWidth) {
            $(window).on("resize", event => {
                this.setState({
                    slideWidth: (window.innerWidth - SLIDE_GAP * 4 - 80) / 3
                });
            });
        }
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.canvasController?.canvas?.isAnimating;
    }

    render() {
        const { slideWidth } = this.state;
        const { onSelect, isGenerating, slideCategories } = this.props;

        if (isGenerating) {
            return (
                <ProgressContainer>
                    <AiGenerateProgress label="Generating ideas..." fontSize={18} />
                </ProgressContainer>
            );
        }

        return (
            <Container ref={this.ref}>
                <SlidesContainer>
                    {slideCategories.map((category, idx) => (
                        <SlideCategory key={idx}>
                            <CategoryLabel>{category.slideCategory.replace("_", " ").toTitleCase()} slides&nbsp;&nbsp;
                                <ToolTipBadge><strong>Why did we suggest {category.slideCategory.replace("_", " ").toTitleCase()} slides? ({category.slideConfidence}% match)</strong><br /><br />{category.slideReasoning}</ToolTipBadge>
                            </CategoryLabel>
                            {
                                category.models.map((model, idx) => (
                                    <CanvasPreview key={idx} slideModel={model} scale={slideWidth / 1280} outlineColor="#555" onClick={() => onSelect(model)} />
                                ))
                            }
                        </SlideCategory>
                    ))}
                </SlidesContainer>
            </Container>
        );
    }
}

export default SlideAiController.withState(SlideAiIdeasList);

